import React from "react";
import cs from "classnames";

import { LightBox } from "@braintrust/braintrust-ui-components";

import { FileCommonBox } from "./file-common-box";

import styles from "./styles.module.scss";

type ImagePreviewProps = {
  title: string;
  src: string;
  thumbnail?: string | null;
  showThumbnail?: boolean;
  size?: number;
};

export const ImagePreview = ({
  title,
  src,
  thumbnail,
  showThumbnail,
  size,
}: ImagePreviewProps) => {
  return (
    <LightBox
      content={<LightBoxContent title={title} src={src} isInLightBox />}
      preview={
        <a
          onClick={(ev) => {
            if (!ev.metaKey && !ev.ctrlKey) {
              return ev.preventDefault();
            }

            ev.stopPropagation();
          }}
          className={`${styles.postAttachment} ${styles.postAttachmentImage}`}
          href={src}
          rel="noopener noreferrer"
          target="_blank"
        >
          <FileCommonBox
            color="var(--grey-1)"
            name={title}
            size={size}
            previewThumbnail={
              <LightBoxContent
                title={title}
                src={showThumbnail && thumbnail ? thumbnail : src}
              />
            }
          />
        </a>
      }
    />
  );
};

type LightBoxContentProps = {
  title: string;
  src: string;
  isInLightBox?: boolean;
};

const LightBoxContent = ({
  src,
  title,
  isInLightBox,
}: LightBoxContentProps) => {
  return (
    <div
      className={cs(styles.postAttachmentContainer, {
        [styles.postAttachmentContainerInLightBox]: isInLightBox,
      })}
    >
      <img
        alt="Post attachment"
        src={src}
        title={title}
        width="auto"
        height="auto"
      />
    </div>
  );
};
